export const selectVideo = ({ mediaDevicePermission }) => mediaDevicePermission.video
export const selectAudio = ({ mediaDevicePermission }) => mediaDevicePermission.audio
export const selectModal = ({ mediaDevicePermission }) => mediaDevicePermission.modal
export const selectService = ({ mediaDevicePermission }) => mediaDevicePermission.service
